export const autoHideDurationSnackBar = 6000;